import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, Box, AppBar, Toolbar } from '@material-ui/core';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import { makeStyles } from '@material-ui/core/styles';

export default function LandingItem(props) {
  const { t } = useTranslation();
  const [isDesktop, isMobile] = useCheckScreenSize();

  const useStyles = makeStyles(theme => ({
    title: {
      paddingTop: '17px',
    },
    paragraph: {
      color: '#222222',
      textAlign: 'center',
      fontSize: isDesktop ? '16px' : '16px',
      lineHeight: '20px',
      marginTop: isDesktop ? '14px' : '14px',
    },
  }));
  const classes = useStyles();

  return (
    <Grid
      container
      direction={'column'}
      justify="center"
      style={{
        width: isDesktop ? '310px' : 'auto',
      }}
    >
      <Grid item xs>
        <Box display={'block'} textAlign={'center'}>
          <img
            src={props.illustration}
            alt="illustration"
            style={{ height: '160px' }}
          />
        </Box>
      </Grid>
      <Grid item xs>
        <Box
          mx={'17px'}
          className={isDesktop ? classes.textDesktop : classes.textMobile}
          justify="center"
        >
          {t(props.paragraphs, { returnObjects: true }).map((p, ix) => {
            return (
              <Typography
                variant={'body1'}
                className={classes.paragraph}
                key={ix}
                style={{
                  fontWeight: ix === 0 ? 'bold' : 'normal',
                }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: t(p, { interpolation: { escapeValue: true } }),
                  }}
                />
              </Typography>
            );
          })}
        </Box>
      </Grid>
    </Grid>
  );
}
